<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">

      <div class="xblock layui-form">
        <div class="layui-input-inline country_select xblock-row" v-if="uid == 1">
          <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
            <option value="0">全部</option>
            <option :value="item.id" v-text="item.name" v-for="(item,index) in warehouseList" v-bind:key="index">
            </option>
          </select>
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="请输入快递编号" v-on:keydown.13="get_recharge_record(true)"
            v-model="id" autocomplete="off" class="layui-input" />
        </div>
        <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="get_recharge_record(true)"><i
            class="fa fa-search"></i></button>
        <span class="x-right xblock-row" v-text="'共有数据：'+count+ '条'"></span>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>仓库</th>
            <th>快递单号</th>
            <td>入库记录</td>
            <th>扫码时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
            <td>
              <div style="width: 45px;">
                <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
              </div>
            </td>
            <td v-on:click="logsearch(item.shipment_number)">
              <a class="log-number" v-text="item.shipment_number"></a>
            </td>
            <td>
              <div style="width: 55px;">
                <i class="status-box status-box-red">已签收</i>
              </div>
            </td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition v-if="list.length < 1"></K-Transition>

    </div>

    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'LogList',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        id: null,
        uid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        current_status: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        warehouseList: warehouseList
      }
    },
    mounted() {
      self = this;
      self.uid = localStorage.getItem("ExShopee_id");
      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.on('select(status_selection)', function(data) {
          self.current_status = data.value;
          self.get_recharge_record(true)
        });
        form.render('select');

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record(e) {
        self.loading = true;
        let param = new URLSearchParams()
        if (e) {
          self.list = [];
        }
        if (self.id) {
          param.append('id', self.id)
        }
        param.append('status', self.current_status)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/receveide_express_record/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.list = datas.list;
            self.count = datas.page.count;
            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();
          });

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      logsearch(txt) {
        window.open("https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=" + txt);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .log-number {
    cursor: pointer;
  }

  .log-number:hover {
    color: #007AFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/deliveryman/LogList.vue